import React from 'react';
import DelegationHeader from "../DelegationHeader/DelegationHeader";
import DelegationList from "../DelegationList/DelegationList";

const DelegationCard = ({ members }) => {
    return (
        <div 
            className="atlar-card w-100 h-100 d-flex flex-column" 
            style={{ padding: "24px 32px" }}
        >
            <DelegationHeader totalMembers={members?.length || 0} />
            
            <div className="flex-grow-1">
                <DelegationList members={members} />
            </div>
        </div>
    );
};

export default DelegationCard;